export function setupBackgroundLazyLoading() {
  // Find elements with data-bg-src attribute
  const lazyBackgrounds = document.querySelectorAll('[data-bg-src]');

  if (!lazyBackgrounds.length) return;

  if (!('IntersectionObserver' in window)) {
    // Fallback for browsers without IntersectionObserver
    lazyBackgrounds.forEach(el => {
      const bgUrl = el.getAttribute('data-bg-src');
      if (bgUrl) {
        const img = new Image();
        img.onload = function() {
          const currentBg = el.style.backgroundImage;
          // Replace the blurhash URL with the actual image URL
          el.style.backgroundImage = currentBg.replace(
            /url\(['"]?([^'")]+)['"]?\)/gi,
            `url("${bgUrl}")`
          );
          el.setAttribute('data-bg-loaded', 'true');
          el.removeAttribute('data-bg-src');
        };
        img.src = bgUrl;
      }
    });
    return;
  }

  const bgObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const bgUrl = el.getAttribute('data-bg-src');

        if (bgUrl) {
          // Preload the image first
          const img = new Image();
          img.onload = function() {
            const currentBg = el.style.backgroundImage;
            // Replace the blurhash URL with the actual image URL
            el.style.backgroundImage = currentBg.replace(
              /url\(['"]?([^'")]+)['"]?\)/gi,
              `url("${bgUrl}")`
            );
            el.setAttribute('data-bg-loaded', 'true');
            el.classList.add('bg-loaded');
          };
          img.src = bgUrl;

          // Stop observing the element
          observer.unobserve(el);
          el.removeAttribute('data-bg-src');
        }
      }
    });
  }, {
    rootMargin: '200px' // Preload backgrounds earlier than regular images
  });

  // Observe all elements with data-bg-src
  lazyBackgrounds.forEach(el => {
    bgObserver.observe(el);
  });
}